'use client';

import { useEffect, useState } from 'react';
import ToastContainer from '@/components/ToastContainer';
import { ConditionalGlobalCart } from '@/components/global/ConditionalGlobalCart';

export default function DeferredClientUi() {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const onIdle = () => setIsReady(true);

    if (typeof window === 'undefined') {
      return;
    }

    if ('requestIdleCallback' in window) {
      const idleId = window.requestIdleCallback(onIdle, { timeout: 1000 });
      return () => window.cancelIdleCallback(idleId);
    }

    const timeoutId = setTimeout(onIdle, 250);
    return () => clearTimeout(timeoutId);
  }, []);

  if (!isReady) {
    return null;
  }

  return (
    <>
      <ConditionalGlobalCart />
      <ToastContainer />
    </>
  );
}
